module.exports = "/_next/static/resources/single-38f7a43c1121366a52ed9a1dac77df42.jpg";